/**
 * Versión del bundle que ejecuta el navegador (commit del build, horneado por
 * el Dockerfile como VITE_GIT_SHA). Se muestra discreto en el pie del login para
 * poder confirmar qué versión corre el navegador y detectar un bundle viejo
 * servido desde caché tras un redeploy. El servidor expone la suya en
 * /v1/health (buildSha); si difieren, el navegador tiene un bundle cacheado.
 */

/** SHA del bundle actual ("dev" en local o si el build arg viene vacío). */
export function bundleSha(): string {
  return import.meta.env.VITE_GIT_SHA || "dev";
}

export function AppVersion() {
  const sha = bundleSha();
  return (
    <p
      style={{ textAlign: "center", fontSize: 11, color: "var(--ink-soft)", opacity: 0.7, marginTop: 4 }}
      title="Versión del bundle en tu navegador (compárala con /v1/health)"
    >
      build {sha}
    </p>
  );
}
